define.alias("shared/components/shared/post/secondary/hashtag-suggestions/auto", "media/components/shared/post/secondary/hashtag-suggestions/auto");